
import React from "react";
import { DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { ApparelProduct } from "@/types";
import { formatCurrency } from "@/lib/format";

interface ProductInfoProps {
  product: ApparelProduct;
}

export const ProductInfo: React.FC<ProductInfoProps> = ({ product }) => {
  const isOutOfStock = product.has_inventory && 
    product.inventory_count !== null && 
    product.inventory_count <= 0;

  return (
    <DialogHeader className="text-left space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
        <div className="space-y-1">
          <DialogTitle className="text-xl font-semibold leading-tight">{product.name}</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            {product.category}
          </DialogDescription>
        </div>
        <div className="text-xl font-semibold">
          {formatCurrency(product.price_cents / 100)}
        </div>
      </div>

      {isOutOfStock && (
        <Badge 
          variant="outline" 
          className="self-start mt-2 bg-red-50 border-red-200 text-red-700 px-3 py-1"
        >
          Out of Stock
        </Badge>
      )}

      {product.description && (
        <p className="text-sm text-muted-foreground leading-relaxed">
          {product.description}
        </p>
      )}

      {product.has_inventory && product.inventory_count !== null && product.inventory_count > 0 && (
        <p className="text-sm flex items-center gap-1">
          <span className={`w-2 h-2 rounded-full ${
            product.inventory_count > 5 ? 'bg-green-500' : 'bg-amber-500'
          }`} />
          {product.inventory_count} in stock
        </p>
      )}
    </DialogHeader>
  );
};
